import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import { useNavigate, useLocation } from "react-router-dom";

function ClientOrder() {

    const userID = sessionStorage.getItem("TRCUserId");
    const userEmail = sessionStorage.getItem("TRCUserEmail");
    const userName = sessionStorage.getItem("TRCUserName");
    const userPosition = sessionStorage.getItem("TRCUserPosition");
    const userType = sessionStorage.getItem("TRCUserType");
    const location = useLocation();

    const [productData, setProductData] = useState([]);
    const [clientData, setClientData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedClent, setSelectedOption] = useState('');
    const [qty, setQty] = useState(1);
    const [selectedProduct, setProduct] = useState('');
    const [cartError, setCartError] = useState(false);
    const [error, setError] = useState('');
    const [cartItems, setCartItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [gst, setGST] = useState(0);
    const [orderError, setOrderError] = useState(false);
    const [errorClient, setClientError] = useState('');
    const [routes, setRoutes] = useState('');
    const [dealerData, setDealerData] = useState('');
    const [inputData, setinputData] = useState('');
    const [filterDealer, setFilterDealer] = useState('');
    const clientId = new URLSearchParams(location.search).get("id");



    function triggerError() {
        setCartError(true);
        setTimeout(() => {
            setCartError(false);
            setError('');
        }, 2000);
    }

    function triggerClientError() {
        setOrderError(true);
        setTimeout(() => {
            setOrderError(false);
            setClientError('');
        }, 2000);
    }

    const filerDealer = () => {
        const dealerInfo = dealerData && dealerData?.filter(dealer => dealer.id === selectedClent);
        if(dealerInfo[0]){
            setinputData((prevData) => ({
                ...prevData,
                ['route']: dealerInfo[0].routeId,
                ['location']: dealerInfo[0].locationId,
            }));
        }
        //console.log(dealerInfo);
    };
    
    useEffect(() => {
        filerDealer();
    },[selectedClent]);

    const filteredOptions = dealerData && dealerData?.filter(option =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        option.dealer.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const selectedClentData = clientData?.filter(client => client.id === selectedClent);
    
    const handleSelect = (option) => {
        setSelectedOption(option);
    };



    const getCart = () => {
        const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
        setCartItems(cartItems);
        let total = 0;
        let gst = 0;
    
        cartItems.forEach(item => {
            const price = parseFloat(item.price);
            const qty = parseFloat(item.qty);
            const gstPercentage = parseFloat(item.gst);
    
            total += price * qty;
    
            gst += (price * qty) - ((price * qty) / (1 + gstPercentage / 100));
        });
        
        setTotal(total);
        setGST(gst);
    };
    



    const getClient = async () => {
        try {
            const response = await axios.post('https://api.trucoo.in/clients/clients/', {userId: userID}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            //console.log(response.data);

            if(response.data.status === 'success'){
                setClientData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };




    const getProducts = async () => {
        try {
            const response = await axios.post('https://api.trucoo.in/products/all-product/', {userId: userID}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            //console.log(response.data);

            if(response.data.status === 'success'){
                setProductData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const getRoutes = async () => {
        try {
            const response = await axios.post('https://api.trucoo.in/routes/view/',{}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            if(response.data.status === 'success'){
                setRoutes(response.data.routes);
                
            }
    
            
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const getDealerData = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/dealers/view/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setDealerData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };
    console.log("dealer",dealerData)




    useEffect(() => {
        getClient();
        getProducts();
        getCart();
        getDealerData();
        getRoutes();
    },[]);

    const newData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
          ...prevData,
          [name]: value,
          ['userId']: userID
        }));
    };

    const changeQty = (e) => {
        const qtys = e.target.value;
        setQty(qtys);
    };



    const changeQtyBtn = (calc) => {
        if(calc === 'plus'){
            setQty(parseFloat(qty)+1);
        }else{
            if(qty === 0){
                setQty(qty);
            }else{
                setQty(parseFloat(qty)-1);
            }
        }
    };




    const addCart = () => {

        if(selectedProduct === '' || !selectedProduct){
            setError('Please select product');
            triggerError();
        }else{

            if(qty === 0 || !qty){
                setError('Please select quantity atleast 1');
                triggerError();
            }else{

                const existingCartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
                const existingItemIndex = existingCartItems.findIndex(item => item.product === selectedProduct);

                if (existingItemIndex !== -1) {
            
                    const newQty = parseFloat(existingCartItems[existingItemIndex].qty) + parseFloat(qty);
                    if (!isNaN(newQty) && newQty > 0) {
                        existingCartItems[existingItemIndex].qty = newQty;
                    } else {
                        console.log("Invalid quantity");
                    }
                }else{

                    const product = productData.find((product) => product.id === selectedProduct);
                    const price = product ? product.productPrice : null;
                    const name = product ? product.productName : null;
                    const productWeight = product ? product.productWeight : null;
                    const productUnit = product ? product.unit : null;
                    const productGst = product ? product.productGst : null;

                    const newItem = {
                        product: selectedProduct,
                        qty: qty,
                        price: price,
                        name: name,
                        weight: productWeight,
                        unit: productUnit,
                        gst: productGst
                    };

                    existingCartItems.push(newItem);
                }

                sessionStorage.setItem('cartItems', JSON.stringify(existingCartItems));
                getCart();
            }
        }
        setQty(0);
    };

    const removeItem = (id) => {
        const updatedCartItems = cartItems.filter(item => item.product !== id);
        sessionStorage.setItem('cartItems', JSON.stringify(updatedCartItems));
        getCart();
    };

    

    const placeOrder = async () => {
            if (cartItems.length === 0) {
                setClientError('Please Add Items!');
                triggerClientError();
            
            } else {
                // Get Geolocation
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        async (position) => {
                            const latitude = position.coords.latitude;
                            const longitude = position.coords.longitude;
                            const location = `${latitude}, ${longitude}`;
                            const currentDate = new Date().toISOString().split('T')[0]; 
        
                            const orderData = {
                                userId: userID,
                                dealer: inputData.dealer,
                                client: clientId,
                                total: total,
                                gst: gst,
                                items: cartItems,
                                latitude: latitude,
                                longitude: longitude,
                                location: location,
                                date: currentDate,
                                advance: 0,  
                                balance: total, 
                            };
        
                            try {
                                const response = await axios.post(
                                    'https://api.trucoo.in/marketing/new-orders/',
                                    orderData,
                                    {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'X-API-KEY': 'erpTrucoo',
                                        },
                                    }
                                );
                                console.log("order data",orderData)
        
                                if (response.data.status === 'success') {
                                    sessionStorage.removeItem('cartItems');
                                    getCart();
                                    setQty(0);
                                    setSelectedOption('');
                                    setSearchTerm('');
                                    setProduct('');
                                    setGST('');
                                    setTotal('');
                                    alert('Order Placed Successfully!');
                                } else {
                                    alert('Order placement failed. Please try again.');
                                    console.log(response.data)
                                }
                            } catch (error) {
                                console.error(error);
                                alert('An error occurred while placing the order.');
                            }
                        },
                        (error) => {
                            console.error('Error getting location:', error);
                            alert('Failed to get location. Please allow location access and try again.');
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    alert('Geolocation is not supported by your browser');
                }
            }
        };
return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
        
            <section class="content">
                <div class="box box-body">
                    
                    <div class="row">
                       
                        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-12">
                            <div class="box">
                                <div class="box-body">

                                    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>New Order</h4>
                                    <hr class="my-15" />

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="form-label">Select Product</label>
                                                <select className="form-select" name="product" valu={selectedProduct} onChange={(e)=> setProduct(e.target.value)} required >
                                                    <option value="" hidden>Select Product</option>
                                                    {productData?.map((product, index) => 
                                                        <option value={product.id}>{product.productName}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label class="form-label">Quantity</label>
                                                <div class="input-group">
                                                    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('minus')}}>-</button>
                                                    <input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="phone" value={qty} onChange={changeQty} required />
                                                    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('plus')}}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mt-4" align="right">
                                            {cartError && <p class="text-danger">{error}</p> }
                                            <button type="button" class="btn btn-primary btn-sm mt-2" onClick={addCart}>Add Item</button>
                                        </div>

                                       

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="form-label">Route</label>
                                                <select class="form-select" name="route" value={inputData.route} onChange={(e)=>newData(e)}>
                                                    <option value="">Select a route</option>
                                                    {routes && routes?.map((route, index)=>
                                                        <option key={index} value={route.id}>{route.route}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="form-label">Place</label>
                                                <select class="form-select" name="location" value={inputData.location} onChange={(e)=>newData(e)}>
                                                    <option value="">Select a route</option>
                                                    {inputData.route && routes[parseFloat(inputData.route)-1]?.locations?.map((location, index)=>
                                                        <option key={index} value={location.id}>{location.location}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="form-label">Dealer</label>
                                                <select class="form-select" name="dealer" value={inputData.dealer} onChange={(e)=>newData(e)}>
                                                    <option value="">Select a dealer</option>
                                                    {dealerData && dealerData?.map((dealer, index)=>
                                                        <option key={index} value={dealer.id}>{dealer.name} - {dealer.dealer}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-12">
                            <div class="box">
                                <div class="box-body">
                                    <h4 class="box-title text-primary mb-0"><i class="ti-save me-15"></i>Order Info</h4>
                                    <hr class="my-15" />
                                    <div class="row">
                                    {cartItems.length > 0 ?
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th width="40%">Product</th>
                                                    <th width="10%">Qty</th>
                                                    <th width="15%">Unit Price</th>
                                                    <th width="15%">Ltr</th>
                                                    <th width="20%">Total</th>
                                                    <th width="15%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cartItems?.map((product, index) => 
                                                <tr>
                                                    <td>{product.name}</td>
                                                    <td>{product.qty}</td>
                                                    <td>{parseFloat(product.price).toFixed(2)}</td>
                                                    <td>{(parseFloat(product.qty) * parseFloat(product.weight) / 1000).toFixed(2)}</td>
                                                    <td>{(parseFloat(product.price) * parseFloat(product.qty)).toFixed(2)}</td>
                                                    <td class="table-action min-w-100">
                                                        <button class="form-control text-fade hover-primary" onClick={() => removeItem(product.product)}><i class="fa fa-trash"></i></button>
                                                    </td>
                                                </tr>
                                                )}
                                                <tr>
                                                    <td colspan="4"></td>
                                                    <td >Sub Total</td>
                                                    <td style={{textAlign: 'right'}}>{parseFloat(total-gst).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4"></td>
                                                    <td >GST</td>
                                                    <td style={{textAlign: 'right'}}>{parseFloat(gst).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4"></td>
                                                    <th  >Grand Total</th>
                                                    <th  style={{textAlign: 'right'}}>{parseFloat(total).toFixed(2)}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                        :
                                        <div align="center" class="mt-4 mb-4"> <p>Add Items</p></div>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
                                    <div class="box-footer" align="center">
                                        {orderError && <p class="text-danger">{errorClient}</p>}
                                        <button class="btn btn-primary" onClick={placeOrder} ><i class="fa fa-shopping-cart"></i> Place Order</button>
                                    </div>  
                        
                                </div>
                            </div>
                        </div>
                     
                    </div>
                
                </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default ClientOrder;